import globalStyles from '../styles/global.css?inline';

const globalSheet = new CSSStyleSheet();

globalSheet.replaceSync(globalStyles);

export const adoptedSheets = [globalSheet];
